import React from "react";
import { Icon } from "./Icon";

interface BankSlipProps {
  size?: number;
  className?: string;
  viewBox?: string;
  color?: string;
}

export const BankSlipPay2B: React.FC<BankSlipProps> = ({
  size = 16,
  className = "",
  viewBox = "0 0 16 16",
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color} viewBox={viewBox}>
      <path d="M1.20312 1.4375C0.813477 1.4375 0.5 1.75098 0.5 2.14062V13.8594C0.5 14.249 0.813477 14.5625 1.20312 14.5625H1.67188C2.06152 14.5625 2.375 14.249 2.375 13.8594V2.14062C2.375 1.75098 2.06152 1.4375 1.67188 1.4375H1.20312ZM3.78125 1.4375C3.52344 1.4375 3.3125 1.64844 3.3125 1.90625V14.0938C3.3125 14.3516 3.52344 14.5625 3.78125 14.5625C4.03906 14.5625 4.25 14.3516 4.25 14.0938V1.90625C4.25 1.64844 4.03906 1.4375 3.78125 1.4375ZM5.89062 1.4375C5.50098 1.4375 5.1875 1.75098 5.1875 2.14062V13.8594C5.1875 14.249 5.50098 14.5625 5.89062 14.5625H6.35938C6.74902 14.5625 7.0625 14.249 7.0625 13.8594V2.14062C7.0625 1.75098 6.74902 1.4375 6.35938 1.4375H5.89062ZM8.70312 1.4375C8.31348 1.4375 8 1.75098 8 2.14062V13.8594C8 14.249 8.31348 14.5625 8.70312 14.5625H9.17188C9.56152 14.5625 9.875 14.249 9.875 13.8594V2.14062C9.875 1.75098 9.56152 1.4375 9.17188 1.4375H8.70312ZM13.625 2.14062V13.8594C13.625 14.249 13.9385 14.5625 14.3281 14.5625H14.7969C15.1865 14.5625 15.5 14.249 15.5 13.8594V2.14062C15.5 1.75098 15.1865 1.4375 14.7969 1.4375H14.3281C13.9385 1.4375 13.625 1.75098 13.625 2.14062ZM11.75 1.90625V14.0938C11.75 14.3516 11.9609 14.5625 12.2188 14.5625C12.4766 14.5625 12.6875 14.3516 12.6875 14.0938V1.90625C12.6875 1.64844 12.4766 1.4375 12.2188 1.4375C11.9609 1.4375 11.75 1.64844 11.75 1.90625Z" />
    </Icon>
  );
};
